import { ColGroupDef } from '@ag-grid-community/core';
import dayjs from 'dayjs';

import { qcCurrentMonthColumnGroup } from './qc-current-month-column-group';
import {
  QuarterCloseGridConfigContext,
  QuarterCloseMonthColumnConfig,
} from './qc-grid-config-context';
import { qcMonthColumnGroup } from './qc-month-column-group';
import { QuarterCloseService } from '../../quarter-close.service';

export const qcMonthColumns = (
  ctx: QuarterCloseGridConfigContext,
  quarterCloseService: QuarterCloseService,
  isFluxAnalysisAvailableAndOn: boolean
): ColGroupDef[] => {
  const m = dayjs(ctx.openMonth);
  const columns: ColGroupDef[] = [];

  ctx.selectedQuarterMonths.forEach((month, index) => {
    const isAfter = m.isAfter(month, 'month');
    const isCurrent = m.isSame(month, 'month');
    const isBefore = m.isBefore(month, 'month');

    if (isCurrent) {
      quarterCloseService.openMonthFieldIndex = index + 1;
    }

    const tmp: QuarterCloseMonthColumnConfig = {
      index: index + 1,
      isAfter,
      isBefore,
      isCurrent,
      month,
    };

    if (isCurrent) {
      columns.push(
        qcCurrentMonthColumnGroup(ctx, tmp, quarterCloseService, isFluxAnalysisAvailableAndOn)
      );
    } else {
      columns.push(qcMonthColumnGroup(ctx, tmp, isFluxAnalysisAvailableAndOn));
    }
  });

  return columns;
};
